import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classname from 'classnames';
import { cardGroupClass } from './styles';
import { PureComponent } from '../component';
import { Provider } from './context';

var CardGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CardGroup, _PureComponent);

  var _super = _createSuper2(CardGroup);

  function CardGroup(props) {
    var _this;

    _classCallCheck(this, CardGroup);

    _this = _super.call(this, props);
    _this.state = {
      scroller: undefined
    };
    _this.bindScroller = _this.bindScroller.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CardGroup, [{
    key: "getGap",
    value: function getGap() {
      // @ts-ignore gap 属性以被重命名了
      var _this$props = this.props,
          gap = _this$props.gap,
          gutter = _this$props.gutter;
      if (gutter !== undefined) return gutter;
      return gap;
    }
  }, {
    key: "bindScroller",
    value: function bindScroller(ref) {
      var scroller = this.state.scroller;
      if (scroller || !ref) return;
      this.setState({
        scroller: ref
      });
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this$props2 = this.props,
          cardWidth = _this$props2.cardWidth,
          columns = _this$props2.columns,
          children = _this$props2.children,
          other = _objectWithoutProperties(_this$props2, ["cardWidth", "columns", "children"]);

      var scroller = this.state.scroller;
      if (!children) return children;
      var gap = this.getGap();
      var context = {
        container: scroller
      };

      var gridStyle = _objectSpread2(_objectSpread2({
        gridRowGap: gap,
        gridColumnGap: gap
      }, other.gridStyle), {}, {
        gridTemplateColumns: cardWidth !== undefined ? "repeat(auto-fill, minmax(".concat(cardWidth, "px, 1fr))") : "repeat(".concat(columns, ", 1fr)")
      });

      return (
        /*#__PURE__*/
        React.createElement(Provider, {
          value: context
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: cardGroupClass('scroller'),
          ref: this.bindScroller
        },
        /*#__PURE__*/
        React.createElement("div", {
          style: gridStyle,
          className: cardGroupClass('grid')
        }, scroller && children)))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          height = _this$props3.height,
          style = _this$props3.style,
          className = _this$props3.className;
      var cls = classname(cardGroupClass('_'), className);

      var groupStyle = _objectSpread2({
        height: height
      }, style);

      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: groupStyle,
          className: cls
        }, this.renderBody())
      );
    }
  }]);

  return CardGroup;
}(PureComponent);

CardGroup.defaultProps = {
  columns: 3,
  gap: 16
};
export default CardGroup;